(ns common.i18n.lang.en
  (:require [common.i18n.icu :as icu]
            [common.i18n.inst-fmt :as inst-fmt]))

;; list of date & time formatting options here https://github.com/tonsky/tongue#localizing-dates
(def inst-strings
  { :weekdays-narrow ["S" "M" "T" "W" "T" "F" "S"]
    :weekdays-short  ["Sun" "Mon" "Tue" "Wed" "Thu" "Fri" "Sat"]
    :weekdays-long   ["Sunday" "Monday" "Tuesday" "Wednesday" "Thursday" "Friday" "Saturday"]
    :months-narrow   ["J" "F" "M" "A" "M" "J" "J" "A" "S" "O" "N" "D"]
    :months-short    ["Jan" "Feb" "Mar" "Apr" "May" "Jun" "Jul" "Aug" "Sep" "Oct" "Nov" "Dec"]
    :months-long     ["January" "February" "March" "April" "May" "June" "July" "August" "September" "October" "November" "December"]
    :dayperiods      ["am" "pm"]
    :eras-short      ["BC" "AD"]
    :eras-long       ["Before Christ" "Anno Domini"] })

(def inst-fmt (partial inst-fmt/tongue-inst-formatter inst-strings))

;;
;; `dictionary.common/`  should be used for the namespace of keys shared across components (since there won't be one component namespace to use)
;;

(def dictionary
  {:dictionary.common/file-type-time-string
   (icu/msg
    "{fileType, select, pdf {{timeString} read} video {{timeString} } audio {{timeString} listen} other { }}"),
   :dictionary.common/time-string
   (icu/msg
    "{hours, plural, =0 {{minutes, plural, =0 {{seconds, plural, other {# sec}}} other {# min}}} other {# hour{minutes, plural, =0 {} other { and # min}}}}."),
   :kyber.components.composite.brand-footer/arcx "ArcheMedX",
   :kyber.components.composite.brand-footer/powered-by "Powered By",
   :kyber.components.composite.brand-footer/privacy-policy
   "Privacy Policy",
   :kyber.components.composite.brand-footer/terms-conditions
   "Terms & Conditions",
   :kyber.components.composite.dropdown-menu/aria-label
   "Application Menu",
   :kyber.components.composite.footer/arcx " ArcheMedX",
   :kyber.components.composite.footer/copyright "© {1}",
   :kyber.components.composite.footer/privacy "Privacy Policy",
   :kyber.components.composite.footer/rights-reserved
   ", all rights reserved.",
   :kyber.components.composite.footer/support "Support",
   :kyber.components.composite.footer/terms "Terms & Conditions",
   :kyber.components.composite.gdpr/form-message
   (icu/msg
    "By {context, select, signIn {signing in} signUp {signing up} other {continuing}}, you are acknowledging that you understand and accept the ArcheMedX "),
   :kyber.components.composite.gdpr/link "Privacy Policy",
   :kyber.components.composite.gdpr-splash/disclaimer
   "By continuing, you are acknowledging that you understand and accept the ",
   :kyber.components.composite.gdpr-splash/policy
   "ArcheMedX privacy policy",
   :kyber.components.composite.group-readiness-composition-chart/high-readiness
   "High Readiness",
   :kyber.components.composite.group-readiness-composition-chart/incompleters
   "Incompleters*",
   :kyber.components.composite.group-readiness-composition-chart/low-readiness
   "Low Readiness",
   :kyber.components.composite.group-readiness-composition-chart/med-readiness
   "Medium Readiness",
   :kyber.components.composite.group-readiness-composition-chart/no-performance-data
   "No performance data",
   :kyber.components.composite.hr-manager-card-group/full-name
   "{given-name} {family-name}",
   :kyber.components.composite.hr-manager-card-group/incompleters
   "*\"Incompleters\" ",
   :kyber.components.composite.hr-manager-card-group/incompleters-desc
   "are learners that have started an activity but have not yet completed it.",
   :kyber.components.composite.hr-manager-card-group/indirect-reports
   "Indirect reports are the aggregation of all direct & indirect reports of any manager that reports to ",
   :kyber.components.composite.hr-manager-card-group/manager "Manager",
   :kyber.components.composite.hr-manager-card-group/report-to-list
   "This is a list of managers that report to ",
   :kyber.components.composite.hr-manager-card-group/reporting-managers
   "Reporting Managers",
   :kyber.components.composite.media-player/audio-file-header
   "Audio File",
   :kyber.components.composite.passwordless-sign-in/access-this
   "access this {1}",
   :kyber.components.composite.passwordless-sign-in/check-email
   "Check your email.",
   :kyber.components.composite.passwordless-sign-in/different-button
   "Send to a different email",
   :kyber.components.composite.passwordless-sign-in/enter-email-to
   "Enter your email to {1}",
   :kyber.components.composite.passwordless-sign-in/give-access
   "give you access to this {1}",
   :kyber.components.composite.passwordless-sign-in/has-link
   "It has a link that'll {1}.",
   :kyber.components.composite.passwordless-sign-in/link-expired
   "That link expired! — ",
   :kyber.components.composite.passwordless-sign-in/no-email
   "Didn't get the email? ",
   :kyber.components.composite.passwordless-sign-in/resend-button
   "resend",
   :kyber.components.composite.passwordless-sign-in/sent-to
   "We sent an email to {1}.",
   :kyber.components.composite.passwordless-sign-in/sign-in "sign-in",
   :kyber.components.composite.passwordless-sign-in/sign-you-in
   "sign you in",
   :kyber.components.composite.passwordless-sign-in/wrong-email
   "Wrong email? ",
   :kyber.components.composite.passwordless-sign-in/oops-wrong-place
   "Oops! You're in the Wrong Place. Please press the button below to access the educational program.",
   :kyber.components.composite.passwordless-sign-in/access-education
   "Access the Education",
   :kyber.components.composite.pdf-viewer/search-placeholder
   "Search Document",
   :kyber.components.composite.pdf-viewer/search-result-counter
   "{1} of {2}",
   :kyber.components.composite.pdf-viewer/search-result-none
   "No Results",
   :kyber.components.composite.rate/rate-label
   (icu/msg "{rate, select, 075 {0.75X} 1 {1X} 125 {1.25X} other {}}"),
   :kyber.components.composite.videojs-player/no-support
   "To view this video please enable JavaScript, and consider upgrading to a web browser that ",
   :kyber.components.composite.videojs-player/no-support-link
   "supports HTML5 video",
   :kyber.components.form-fields.select/add-select-option-display
   "Select an option",
   :kyber.components.forms.free-form-question/best-practices
   "Best Practices",
   :kyber.components.forms.free-form-question/body
   "Lorem ipsum dolor sit amet, consectetur adipiscing do eiusmod tempor incididunt ut labore et dolore aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
   :kyber.components.forms.free-form-question/cancel "cancel",
   :kyber.components.forms.free-form-question/default-text "Submit",
   :kyber.components.forms.free-form-question/error
   "Please fix the errors to the left.",
   :kyber.components.forms.free-form-question/header
   "Add a freeform text based question:",
   :kyber.components.forms.free-form-question/placeholder
   "Enter question",
   :kyber.components.forms.free-form-question/required "Required",
   :kyber.components.forms.inline-field-form/confirm-text "Remove",
   :kyber.components.forms.inline-field-form/deny-text "Keep",
   :kyber.components.forms.inline-field-form/loading-label "updating...",
   :kyber.components.forms.inline-field-form/no-value-label
   "No Value Set",
   :kyber.components.forms.multi-answer-question/best-practices-copy
   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
   :kyber.components.forms.multi-answer-question/card-title
   "Add a new multiple answer question:",
   :kyber.components.forms.multi-answer-question/validator-max
   "We recommend that you have at max 5 answers.",
   :kyber.components.forms.multi-answer-question/validator-min
   "We recommend that you have more than 2 answers.",
   :kyber.components.forms.multi-answer-question/validator-required
   "Require at least 2 answers",
   :kyber.components.forms.multiple-choice-question-base/answer-placeholder
   "Enter answer",
   :kyber.components.forms.multiple-choice-question-base/best-practices
   "Best Practices",
   :kyber.components.forms.multiple-choice-question-base/cancel "cancel",
   :kyber.components.forms.multiple-choice-question-base/other-option-label
   "Include other option?",
   :kyber.components.forms.multiple-choice-question-base/question-placeholder
   "Enter question",
   :kyber.components.forms.multiple-choice-question-base/question-validator-required
   "Required",
   :kyber.components.forms.multiple-choice-question-base/submit "Submit",
   :kyber.components.forms.multiple-choice-question-base/submit-error
   "Please fix the errors to the left.",
   :kyber.components.forms.multiple-choice-question-base/validator-required
   "Required",
   :kyber.components.forms.passwordless-sign-in/label "Email",
   :kyber.components.forms.passwordless-sign-in/submit "Submit",
   :kyber.components.forms.passwordless-sign-in/validator-invalid
   "Invalid email address",
   :kyber.components.forms.passwordless-sign-in/validator-required
   "Required",
   :kyber.components.forms.single-answer-question/best-practices-copy
   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
   :kyber.components.forms.single-answer-question/card-title
   "Add a new single answer question:",
   :kyber.components.forms.single-answer-question/max-answers
   "We recommend that you have at max 5 answers.",
   :kyber.components.forms.single-answer-question/min-answer
   "We recommend that you have more than 2 answers.",
   :kyber.components.forms.single-answer-question/required
   "Require at least 2 answers",
   :kyber.components.forms.user-profile/family-name-label "Last Name",
   :kyber.components.forms.user-profile/given-name-label "First Name",
   :kyber.components.forms.user-profile/submit "Save Changes",
   :kyber.components.forms.user-profile/validator-family-name "Required",
   :kyber.components.forms.user-profile/validator-given-name "Required",
   :kyber.components.forms.user-profile/validator-participant-id "Required",
   :kyber.containers.privacy-policy/about-pixels
   "We may also use pixel tags (which are also known as web beacons and clear\nGIFs) on our site or through 3rd party email communications to track the actions\nof users on our site. Unlike cookies, which are stored on the hard drive of your\ncomputer or mobile device by a website, pixel tags are embedded invisibly on\nwebpages. Pixel tags measure the success of our communications and compile\nstatistics about usage of the site, so that we can manage our content more\neffectively. The information we collect using pixel tags is not linked to our\nusers’ personal data.",
   :kyber.containers.privacy-policy/addr-1 "300 E Main St Suite 101",
   :kyber.containers.privacy-policy/addr-2 "Charlottesville, VA 22902 ",
   :kyber.containers.privacy-policy/addr-3 "E-mail: info@archemedx.com",
   :kyber.containers.privacy-policy/addr-4 "Phone: 434-260-1850",
   :kyber.containers.privacy-policy/an-emergency
   "in an emergency. This includes protecting the safety of our employees\nand agents, our customers, or any person. With those who need it to do work for\nus.",
   :kyber.containers.privacy-policy/automatic-collection
   "Information Automatically Collected.",
   :kyber.containers.privacy-policy/automatic-stuff
   "We automatically log information about you and your computer. For example,\nwhen visiting our site and applications, we log your computer operating system\ntype, browser type, browser language, the website you visited before browsing to\nour site, pages you viewed, how long you spent on a page, access times and\ninformation about your use of and actions on our site.",
   :kyber.containers.privacy-policy/business-deal
   "When we do a business deal, or negotiate a business deal, involving the\nsale or transfer of all or substantially all of our business or assets. These\ndeals can include any merger, financing, acquisition, or bankruptcy transaction\nor proceeding.",
   :kyber.containers.privacy-policy/by-visiting
   "By visiting our site and providing us with your personal data, you\nacknowledge and agree that your personal data may be processed for the purposes\nidentified in this Policy.",
   :kyber.containers.privacy-policy/changes-to-policy
   "CHANGES TO THIS POLICY",
   :kyber.containers.privacy-policy/children "CHILDREN",
   :kyber.containers.privacy-policy/contact-info
   "WHO WE ARE & CONTACT INFORMATION",
   :kyber.containers.privacy-policy/contact-us
   "We welcome your comments about this Policy. If you have any questions about\nhow we use your personal data or wish to have your data removed, please do not\nhesitate to contact us at:",
   :kyber.containers.privacy-policy/cookie-categories
   "There are two broad categories of cookies:",
   :kyber.containers.privacy-policy/cookie-def
   "Cookies are text files containing small amounts of information which are\ndownloaded to your computer or mobile device when you visit a website or mobile\napplication. Cookies are then sent back to the originating site on each\nsubsequent visit, or to another site that recognises that cookies. You can find\nout more information about cookies at www.allaboutcookies.org.",
   :kyber.containers.privacy-policy/cookie-enhancers
   "We use cookies to enhance the online experience of our visitors (for\nexample, by remembering your language and/or product preferences) and to better\nunderstand how our site is used. Cookies may tell us, for example, whether you\nhave visited our site before or whether you are a new visitor. They can also\nhelp to ensure that adverts you see online are more relevant to you and your\ninterests.",
   :kyber.containers.privacy-policy/cookie-types "Types of Cookies",
   :kyber.containers.privacy-policy/cookies "COOKIES",
   :kyber.containers.privacy-policy/edit-delete-access
   "HOW TO EDIT, DELETE OR ACCESS YOUR PERSONAL DATA",
   :kyber.containers.privacy-policy/feel-confident
   "We want you to feel confident about using our site and applications, and we\nare committed to protecting the personal information we collect. We limit access\nto personal information about you to employees who reasonably need access to it,\nto provide products or services to you or in order to do their jobs. We have\nappropriate technical and organizational physical, electronic, and procedural\nsafeguards to protect the personal information that you provide to us against\nunauthorized or unlawful processing and against accidental loss, damage or\ndestruction.",
   :kyber.containers.privacy-policy/find-out
   "You can find out more about ArcheMedX Inc. and the Terms of Use for\nusing our site at www.archemedx.com.",
   :kyber.containers.privacy-policy/first-party-cookies
   "First Party Cookies",
   :kyber.containers.privacy-policy/for-legal
   "For legal, protection, and safety purposes;",
   :kyber.containers.privacy-policy/from-others
   "Information We Get From Others.",
   :kyber.containers.privacy-policy/gdpr
   "In accordance with the disclosure requirements of the European Union's\nGeneral Data Protection Regulation (\"GDPR\"), we do not use any data we collect\nfrom you that impact your individual rights.",
   :kyber.containers.privacy-policy/header "Privacy Policy",
   :kyber.containers.privacy-policy/headquarters
   "ArcheMedX Inc. is a company headquartered at 300 E Main St Suite 101,\nCharlottesville, VA 22902.",
   :kyber.containers.privacy-policy/how-to-delete
   "How to control or delete cookies",
   :kyber.containers.privacy-policy/international-data
   "INTERNATIONAL TRANSFER OF PERSONAL DATA",
   :kyber.containers.privacy-policy/ip-addr "IP Addresses",
   :kyber.containers.privacy-policy/last-updated
   "Last updated: March 18, 2020",
   :kyber.containers.privacy-policy/learner-data
   "We can share individual and aggregated learner data and performance\nstatistics to authorized users within your organization.",
   :kyber.containers.privacy-policy/learner-performance
   "We also collect information about learner performance and patterns of\nlearning. We track information indicating things such as which sections of our\napplication were visited, the order in which they were visited, when they were\nvisited, what notes were taken, what searches were conducted, what reminders\nwere set, which resources were viewed and which hyperlinks and other user\ninterface controls were used. We encourage you to review the privacy statements\nof websites you choose to link to from our website so that you can understand\nhow those websites collect, use, and share your information. We are not\nresponsible for the privacy statements or other content on websites outside of\nour website.",
   :kyber.containers.privacy-policy/may-collect
   "We may collect information about your computer or mobile device, including\nwhere available your IP address, operating system, log in times and browser\ntype. We use this information to better understand how visitors use our site and\nfor internal reporting purposes. We will not share this information with any\nadvertisers or marketing companies.",
   :kyber.containers.privacy-policy/more-info
   "Further information about cookies, including how to see what cookies have\nbeen set on your computer or mobile device and how to manage and delete them,\nvisit www.allaboutcookies.org and www.youronlinechoices.eu.",
   :kyber.containers.privacy-policy/name-and-stuff
   "We may collect your name, postal address, email address, phone number,\nfax number, username, password and demographic information (such as your\ngender and occupation) as well as other information you directly give us on\nour site or through our applications. In addition, we may also collect personal\ninformation from you when you correspond with us (for example, when you send\nus e-mail communications or letters, or by telephone). Certain personal data you\nshare with us is mandatory in order for you to use our service.",
   :kyber.containers.privacy-policy/no-rent
   "We do not rent, sell or share personal information about you with other\npeople or non-affiliated companies outside ArcheMedX Inc. except under the\nfollowing circumstances:",
   :kyber.containers.privacy-policy/obtain
   "We obtain information about you in a range of ways:",
   :kyber.containers.privacy-policy/other-sources
   "We may get information about you from other sources. We may add this to\ninformation we get from this site and your use of our applications.",
   :kyber.containers.privacy-policy/outside-eea
   "Your personal data may be collected, processed and/or otherwise transferred\noutside the European Economic Area and may be processed not only in the country\nin which it was collected but also in other countries, including the United\nStates, where data protection and privacy laws and regulations may not offer\nthe same level of protection as in other parts of the world. By providing your\npersonal data to us, you consent to such transfer, collection and/or processing\nin the United States of your personal data, which includes the use of cookies as\ndescribed in this Policy.",
   :kyber.containers.privacy-policy/over-13
   "This site is not directed at anyone who we know to be under the age of 13,\nnor do we collect any personal information from anyone who we know to be under\nthe age of 13. If you are under the age of 13, you should not use the platform\nand should not submit any personal information to us.",
   :kyber.containers.privacy-policy/personal-purposes
   "We use your personal data for the following purposes:",
   :kyber.containers.privacy-policy/pixel-tags "Pixel Tags",
   :kyber.containers.privacy-policy/protecting-your-info
   "PROTECTING YOUR INFORMATION",
   :kyber.containers.privacy-policy/remain-on-device
   "Cookies can remain on your computer or mobile device for different periods\nof time. Some cookies are 'session cookies', meaning that they exist only while\nyour browser is open. These are deleted automatically once you close your\nbrowser. Other cookies are 'permanent cookies,' meaning that they survive after\nyour browser is closed. They can be used by the site to recognise our computer\nor mobile device when you open your browser and browse the Internet again.",
   :kyber.containers.privacy-policy/retain-data
   "We will retain your personal data for the period necessary to fulfill the\npurposes outlined in this Policy unless a longer retention period is required or\npermitted by law.",
   :kyber.containers.privacy-policy/retention-period "RETENTION PERIOD",
   :kyber.containers.privacy-policy/right-to-ask
   "You have the right to ask for a copy of any personal information that we\nhold about you in our records, to correct any inaccuracies and to update any out\nof date information. You can also ask us not to send you direct marketing\ncommunications (however please note that we may continue to send you service\nrelated (i.e. non-marketing) communications, such as email updates). If you wish\nto exercise any of these rights, or wish to object to our use of your personal\ninformation, please write to us at the address given above.",
   :kyber.containers.privacy-policy/right-to-choose
   "You have the right to choose whether or not to accept cookies and we have\nexplained how you can exercise this right below. However, please note that if\nyou do not accept our cookies, you may experience some inconvenience in your use\nof our site.",
   :kyber.containers.privacy-policy/served-directly
   ", served directly by ArcheMedX to your computer or mobile device. They are\nused only by ArcheMedX to recognise your computer or mobile device when it\nrevisits our site.",
   :kyber.containers.privacy-policy/share-aggregated
   "We may also share aggregated and/ or anonymized data with others for their\nown uses, such as scientific research.",
   :kyber.containers.privacy-policy/sharing-data
   "SHARING OF PERSONAL DATA",
   :kyber.containers.privacy-policy/site-provider-served
   ", which are served by a service provider on our site, and can be used by\nthe service provider to recognise your computer or mobile device when it visits\nother sites. Third party cookies are most commonly used for platform analytics\nor advertising purposes.",
   :kyber.containers.privacy-policy/take-a-moment
   "Please take a moment to read this Policy which explains how we collect,\nuse, disclose and transfer the personal information that you provide to us\nwhen you visit our site or use our applications.",
   :kyber.containers.privacy-policy/third-party-cookies
   "Third party cookies",
   :kyber.containers.privacy-policy/this-policy
   "This privacy policy (“Policy”) describes how ArcheMedX, Inc. and its\nrelated companies collect, use and share personal data of users of this website,\nwww.archemedx.com.",
   :kyber.containers.privacy-policy/time-to-time
   "From time to time we may change this Policy. If we make any changes, we\nwill change the Last Updated date above. If you do not agree to these changes,\nplease do not continue to use our site. If material changes are made to this\nPolicy, we will notify you by email or by placing a prominent notice on the\nsite.",
   :kyber.containers.privacy-policy/to-archive
   "to archive such information and/or use it for future communications with\nyou.",
   :kyber.containers.privacy-policy/to-communicate
   "to communicate about updates to course offerings, upcoming events, and\nother news about products and services offered by us and our selected\npartners;",
   :kyber.containers.privacy-policy/to-comply
   "to comply with laws or any regulatory obligation;",
   :kyber.containers.privacy-policy/to-enable
   "to enable our customers to personalize your learning experience and\ndeliver, administer and improve their courses by responding to questions you\npose and review your individual learning activities to optimize learning\noutcomes;",
   :kyber.containers.privacy-policy/to-link
   "to link or combine user information with other personal data;",
   :kyber.containers.privacy-policy/to-operate
   "to operate, maintain, monitor and improve our sites, products and\nservices;",
   :kyber.containers.privacy-policy/to-protect-illegal
   "to protect, investigate, and deter against fraudulent, unauthorized, or\nillegal activity; and",
   :kyber.containers.privacy-policy/to-protect-rights
   "to protect the rights and property of ArcheMedX Inc., our agents,\ncustomers and others. This includes enforcing our agreements, policies and Terms\nof Use.",
   :kyber.containers.privacy-policy/to-provide
   "to provide and deliver products and services at customers request;",
   :kyber.containers.privacy-policy/to-respond-comments
   "to respond to comments and questions and provide customer service;",
   :kyber.containers.privacy-policy/to-respond-lawful
   "to respond to lawful requests and legal processes;",
   :kyber.containers.privacy-policy/to-send
   "to send information including confirmations, invoices, technical notices,\nupdates, security alerts and support and administrative messages;",
   :kyber.containers.privacy-policy/to-track
   "to track individual participation, progress, engagement, and completion\nof an online course, and to analyse statistics on learner performance and how\nusers of our applications learn.",
   :kyber.containers.privacy-policy/use-cookies
   "Our site (like most platforms) uses cookies and other similar technology\nsuch as 'web beacons'.",
   :kyber.containers.privacy-policy/use-of-personal
   "USE OF PERSONAL DATA",
   :kyber.containers.privacy-policy/what-we-collect "WHAT WE COLLECT",
   :kyber.containers.privacy-policy/wide-cookies
   "Cookies are widely used in order to make sites work, or to work more\nefficiently, as well as to provide information to the owners of the platform.",
   :kyber.containers.privacy-policy/with-consent
   "With your consent. For example, you may let us share personal data with\nothers for their own marketing uses. Those uses will be subject to their\nprivacy policies.",
   :kyber.containers.privacy-policy/wut-cookies "What are Cookies?",
   :kyber.containers.privacy-policy/you-give-us
   "Information You Give Us.",
   :kyber.containers.terms-and-conditions/access
   "ACCESS TO AND USE OF THE ARCHEMEDX WEBSITE (“THE SITE”), AND/OR ITS WEB-BASED ONLINE, MOBILE AND WIRELESS POWERED EDUCATION COURSES, LEARNER TRACKING AND ANALYTIC TOOLS, TOGETHER WITH ANY THIRD PARTY CO-BRANDED AND “POWERED BY” VERSIONS THEREOF (COLLECTIVELY THE “APPLICATION”) ARE SUBJECT TO THESE TERMS AND CONDITIONS ( “TERMS AND CONDITIONS”). THE ARCHEMEDX APPLICATION IS DESIGNED FOR HEALTH PROFESSIONALS. TO USE THE APPLICATION, YOU MUST ESTABLISH AN ACCOUNT USING THE ONLINE REGISTRATION PROCESS THROUGH THE SITE OR MEDICAL EDUCATION PROVIDERS (“BUSINESS ASSOCIATES”). BY REGISTERING FOR AND/OR USING THE SITE AND APPLICATION, YOU HEREBY AGREE TO A BINDING AGREEMENT BETWEEN YOU AND ARCHEMEDX (“AGREEMENT”). IF YOU DO NOT AGREE TO THE TERMS AND CONDITIONS OF THIS AGREEMENT DO NOT PROCEED WITH THE REGISTRATION FOR OR USE OF THIS APPLICATION. THIS AGREEMENT INCLUDES BUT IS NOT LIMITED TO, THE ARCHEMEDX PRIVACY POLICY (“PRIVACY POLICY”), INCORPORATED HEREIN BY THIS REFERENCE AS WELL AS ANY AND ALL OTHER AGREEMENTS REFERENCED IN YOUR REGISTRATION FOR OR USE OF THIS APPLICATION. YOU AGREE THAT ARCHEMEDX MAY MODIFY THIS AGREEMENT AT ANY TIME BY POSTING SUCH MODIFIED TERMS AND CONDITIONS (“MODIFICATIONS”) TO THIS WEBSITE, OR APPLICATION. YOUR CONTINUED USE OF THIS WEBSITE OR APPLICATIONS AFTER SUCH POSTING SIGNIFIES YOUR AGREEMENT TO SUCH MODIFICATIONS. FOR PURPOSES OF THESE TERMS AND CONDITIONS ArcheMedX, the Site and the Application may be referenced collectively (though not exclusively) as “we” “us”, “our”. References to “you”, “your” “user” refer to users of the website, mobile or wireless platforms and Application.",
   :kyber.containers.terms-and-conditions/additional-rights
   "Additional Rights. Certain states and or jurisdictions do not allow the\nexclusion of implied warranties or limitation of liability for incidental,\nconsequential or certain other types of damages, so the exclusions set forth\nabove in Section 12, may not apply to you.",
   :kyber.containers.terms-and-conditions/choice-of-law
   "Choice of Law. This Agreement, this Site and the Application are governed\nby and interpreted in accordance with the laws of the Commonwealth of Virginia,\nwithout giving effect to any conflict of laws provisions. By using the Site,\nApplication, and Wireless Platforms you hereby consent to the exclusive\njurisdiction of and agree that venue is proper and convenient in the state and\nfederal courts situated in Charlottesville, Virginia, and the Commonwealth of\nVirginia. Any cause of action you may have with respect to your use of the\nWebsite. Wireless Platform or Applications must be commenced within one (1) year\nafter the claim or cause of action arises thereby expressly waiving any\napplicable statute of limitations.",
   :kyber.containers.terms-and-conditions/content-monitoring
   "Monitoring of Content – ArcheMedX, its partners and Business Associates\nhave no obligation to monitor, screen, edit or otherwise control any Content\nposted on or transmitted through the Site or Application (collectively,\n\"Postings\"). However, ArcheMedX may, in its sole discretion, monitor the\nArcheMedX Site and Application to determine compliance with these Terms and\nConditions and other agreements, and with all applicable laws and regulations.\nArcheMedX may use lawful means to intercept and/or disclose Postings to the\nextent reasonably necessary to protect our rights or the rights of any third\nparty, or to comply with any law, regulation or governmental request. We may\nalso review, edit, and refuse to post or remove any Postings displayed on or\ntransmitted through the ArcheMedX Site and Application.",
   :kyber.containers.terms-and-conditions/copyright
   "Notice Copyright Agent. You may request removal of materials from the\nSite, Application, or Wireless Platforms if you have a good faith belief that\nthe materials infringe your copyright. Please contact ArcheMedX and provide\nthe following information: (i) description and location of the material to\nassist in locating the material; (ii) your name, address, email and telephone\nnumber (3) a statement, signed by the copyright holder that the use of the\nmaterial on the Website is not authorized, that you believe the information you\nhave provided is accurate.",
   :kyber.containers.terms-and-conditions/entire-agreement
   "Entire Agreement. These Terms and Conditions and the ArcheMedX Privacy\nPolicy constitute the entire agreement between ArcheMedX and you with respect\nto the Site, the Wireless Platforms and Application and supersedes all prior\nand contemporaneous communications and proposal, whether electronic, oral or\nwritten between you and ArcheMedX with respect to the Site and Application.",
   :kyber.containers.terms-and-conditions/header "Terms and Conditions",
   :kyber.containers.terms-and-conditions/effective-date "Effective Date:",
   :kyber.containers.terms-and-conditions/sept-2-2025 "September 2, 2025",
   :kyber.containers.terms-and-conditions/these-terms "These Terms (“Agreement”) govern access to and use of the ArcheMedX website and the Ready platform. By registering for and/or using the Ready platform or associated services, you agree to be bound by this Agreement. If you do not agree, you should not use the application.",
   :kyber.containers.terms-and-conditions/scope-and-purpose-title "1. Scope and Purpose",
   :kyber.containers.terms-and-conditions/scope-and-purpose-content "The Ready platform, developed and maintained by ArcheMedX, is a validated digital solution designed to deliver, track, and analyze training related to both clinical trial execution and broader medical education. It is intended for use by healthcare professionals, clinical research personnel, and other authorized users affiliated with sponsors, CROs, or education providers.",
   :kyber.containers.terms-and-conditions/privacy-and-data-protection-title "2. Privacy and Data Protection",
   :kyber.containers.terms-and-conditions/privacy-and-data-protection-content-1 "Your use of the Ready platform is subject to the ArcheMedX Privacy Policy. ArcheMedX collects limited personal data, including your name, work email address, organization, and role. We do not collect medical records, diagnoses, or sensitive personal health information.",
   :kyber.containers.terms-and-conditions/privacy-and-data-protection-content-2 "When operating under contract with a sponsor or CRO, ArcheMedX functions as a data processor, acting on the instructions of the data controller. Data processing is governed by our Data Processing Agreement (DPA), Standard Contractual Clauses (SCCs), and applicable data protection laws such as the GDPR and HIPAA.",
   :kyber.containers.terms-and-conditions/account-registration-title "3. Account Registration and User Responsibilities",
   :kyber.containers.terms-and-conditions/account-registration-content "You are responsible for maintaining the confidentiality of your login credentials and for all activities conducted through your account. You agree to:",
   :kyber.containers.terms-and-conditions/account-registration-bullet-1 "Use the platform solely for authorized purposes",
   :kyber.containers.terms-and-conditions/account-registration-bullet-2 "Provide accurate and current registration information",
   :kyber.containers.terms-and-conditions/account-registration-bullet-3 "Notify ArcheMedX immediately of any unauthorized use or suspected breach",
   :kyber.containers.terms-and-conditions/account-registration-footer "ArcheMedX is not liable for any loss or damage resulting from your failure to protect your account.",
   :kyber.containers.terms-and-conditions/system-validation-title "4. System Validation and Regulatory Compliance",
   :kyber.containers.terms-and-conditions/system-validation-content "The Ready platform operates in a validated environment consistent with the requirements of 21 CFR Part 11 for electronic records. ArcheMedX maintains audit trails, secure authentication, role-based access, and data integrity safeguards. The platform supports authenticated training attestations that meet regulatory expectations for training documentation. Sponsors or CROs may enable formal electronic signatures based on contractual agreement.",
   :kyber.containers.terms-and-conditions/license-title "5. License and Intellectual Property",
   :kyber.containers.terms-and-conditions/license-content "ArcheMedX grants you a non-exclusive, non-transferable license to access and use the Ready platform for your professional, non-commercial use. All content, software, training materials, and analytics tools are the intellectual property of ArcheMedX or its licensors. You may not:",
   :kyber.containers.terms-and-conditions/license-bullet-1 "Copy, modify, distribute, or sublicense the platform or its contents",
   :kyber.containers.terms-and-conditions/license-bullet-2 "Reverse engineer or attempt to extract source code",
   :kyber.containers.terms-and-conditions/license-bullet-3 "Share your account with others",
   :kyber.containers.terms-and-conditions/license-footer "All rights not expressly granted are reserved by ArcheMedX.",
   :kyber.containers.terms-and-conditions/medical-disclaimer-title "6. Medical Disclaimer",
   :kyber.containers.terms-and-conditions/medical-disclaimer-content "The Ready platform does not provide clinical or medical advice. It is a tool for delivering educational content created or approved by sponsors, CROs, or accredited medical education providers. Users are expected to exercise independent judgment and verify the applicability of any content before applying it in clinical or research settings.",
   :kyber.containers.terms-and-conditions/third-party-title "7. Third-Party Interactions",
   :kyber.containers.terms-and-conditions/third-party-content "You may access the Ready platform through co-branded or \"powered by\" environments operated in collaboration with sponsors, CROs, or education partners. These partners may provide content or collect additional information according to their own terms and privacy policies. ArcheMedX is not responsible for the actions or policies of these third parties.",
   :kyber.containers.terms-and-conditions/platform-availability-title "8. Platform Availability and Updates",
   :kyber.containers.terms-and-conditions/platform-availability-content "ArcheMedX may modify or discontinue features of the Ready platform at any time. While we strive for high availability, the platform may be subject to maintenance windows or internet-related disruptions. We do not guarantee uninterrupted access.",
   :kyber.containers.terms-and-conditions/limitation-liability-title "9. Limitation of Liability",
   :kyber.containers.terms-and-conditions/limitation-liability-content "To the fullest extent permitted by law, ArcheMedX disclaims all liability for indirect, incidental, special, or consequential damages arising out of your use of the platform. Your sole remedy is to discontinue use. ArcheMedX's total liability under this Agreement shall not exceed the amount paid by your organization in the preceding 12 months.",
   :kyber.containers.terms-and-conditions/indemnification-title "10. Indemnification",
   :kyber.containers.terms-and-conditions/indemnification-content "You agree to defend, indemnify, and hold harmless ArcheMedX and its affiliates from any claims, damages, or liabilities resulting from your violation of these Terms or misuse of the platform.",
   :kyber.containers.terms-and-conditions/termination-title "11. Termination",
   :kyber.containers.terms-and-conditions/termination-content "ArcheMedX may suspend or terminate your access if you breach this Agreement or misuse the platform. In such cases, we may delete any associated data unless otherwise governed by sponsor agreements.",
   :kyber.containers.terms-and-conditions/governing-law-title "12. Governing Law",
   :kyber.containers.terms-and-conditions/governing-law-content "This Agreement is governed by the laws of the Commonwealth of Virginia. Any disputes shall be resolved in the state or federal courts located in Charlottesville, Virginia.",
   :kyber.containers.terms-and-conditions/notices-title "13. Notices",
   :kyber.containers.terms-and-conditions/notices-content "Legal notices may be sent to:",
   :kyber.containers.terms-and-conditions/notices-company "ArcheMedX, Inc.",
   :kyber.containers.terms-and-conditions/notices-address "300 E Main St, Suite 101\nCharlottesville, VA 22902\nlegal@archemedx.com",
   :kyber.containers.terms-and-conditions/entire-agreement-title "14. Entire Agreement",
   :kyber.containers.terms-and-conditions/entire-agreement-content "These Terms, along with the ArcheMedX Privacy Policy and any applicable DPA or SCCs, constitute the full agreement between you and ArcheMedX regarding use of the Ready platform.",
   :kyber.containers.terms-and-conditions/health-insurance-act
   "The Health Insurance Portability and Accountability Act of 1996. You\nspecifically warrant that any information disclosed in communications to the\nApplication complies with all applicable Health Insurance Portability and\nAccountability Act of 1996 (“HIPAA”) requirements for protecting medical privacy\nas well as any and all other federal and state guidelines in force, now or in\nthe future. It is the sole responsibility of the Users, practitioners,\nresearchers, healthcare professionals, and others who use the Site and the\nApplication to ensure that HIPAA Privacy standards and requirements are met\nwith regard to the authorized disclosure of personal, identifying, and/or\ndemographic information about particular patients, research participants,\nclients, etc., and such responsibilities and duties shall be non-delegable\nand non-assignable.",
   :kyber.containers.terms-and-conditions/indemnification
   "Indemnification. You agree to defend, indemnify and hold harmless\nArcheMedX, its directors officers, agents, employees, licensors, Business\nAssociates and suppliers from and against any and all claims, actions, demands,\nliabilities or losses including reasonable legal and accounting fees resulting\nfrom or alleged to have resulted from your violation of the Terms and Conditions\nof this Agreement, or your use or reliance on the Site, Application, Wireless\nPlatform or any content or information made available therein.",
   :kyber.containers.terms-and-conditions/internet-delays
   "Internet Delays. ARCHEMEDX’S SITE AND APPLICATION MAY BE SUBJECT TO\nLIMITATIONS, DELAYS AND OTHER PROBLEMS INHERENT IN THE USE OF THE INTERNET.\nARCHEMEDX IS NOT RESPONSIBLE FOR ANY DELAYS, DELIVERY FAILURES OR OTHER DAMAGES\nRESULTING FROM SUCH PROBLEMS.",
   :kyber.containers.terms-and-conditions/liability
   "Limitation of Liability. ArcheMedX, its officers, directors, affiliates,\nagents, Licensors, Business Associates and suppliers are not liable for any\nclaims or losses whatsoever of any kind, whether direct, incidental, indirect,\nconsequential, special, punitive or exemplary damages of any kind whether\narising from an action in contract, tort or otherwise, related to or in\nconnection with the Site, the Application, any Wireless Platforms or any other\napplication or information made available on or through this Site or Application\nor your use thereof. ArcheMedX and its affiliates shall additionally not be\nliable for any claims or losses, including lost revenue, or profits, loss of\ndata or business, in connection with or in any way related to the use of or\ninability to use the Site, the Application, the Wireless Platforms or for any\nclaim or injury based upon errors, omissions, interruptions or other\ninaccuracies in the Site, the Application, the Wireless Platforms, or content\nresiding therein, or any decision made or action taken in reliance on the\ncontent contained on or accessible through the Site, the Application, or the\nWireless Platforms, including without limitation personal injury or death,\neven if ArcheMedX has been advised of the possibility of such damages. Your sole\nremedy for any claims in connection with this Site, the Wireless Platforms or\nApplication is to discontinue using the Site, the Application, the Wireless\nPlatforms, and any related information or applications. The foregoing limitation\nshall apply and survive notwithstanding any failure of essential purpose of any\nremedy.",
   :kyber.containers.terms-and-conditions/license
   "License Grant, Restrictions, and Intellectual Property Ownership:\nArcheMedX grants you a non-exclusive, non-transferable right to use the Site\nand Application solely for your personal, non-commercial, non-competitive use,\nsubject at all times to the Terms and Conditions of this Agreement. All forms\nof educational, literary and scientific materials, audio and video content,\ntext, photographs, designs, marks and logos (the “Content”), software, and\nweb-based authoring, tracking and analytic tools (the “Technology”) provided\nthrough the Application and/or the Site are owned, licensed and/or controlled by\nArcheMedX, its third party content publishers (“Licensors”), and Business\nAssociates.",
   :kyber.containers.terms-and-conditions/logo-alt "Archemedx Logo",
   :kyber.containers.terms-and-conditions/no-medical-advice
   "No Medical Advice. You agree that the Site and the Application together\nwith any content provided by or through it, is intended for use as medical\neducation only, not medical advice. This Application is intended for health\nprofessionals. Health professionals who use the Application assume full\nresponsibility for the medically appropriate use of any and all information\ngathered through the Application. You agree as a health professional to\nexercise your independent professional judgment with regard to the information\nprovided by or through the Application and to confirm all information provided\nby or through the Application with professional medical standards applicable\nin your jurisdiction of licensure and those of any professional bodies to\nwhich you belong before basing any treatment on it.",
   :kyber.containers.terms-and-conditions/notices
   "Notices. ArcheMedX may give notice by means of a general notice on the\nApplication, the Site, the Wireless Platforms, electronic mail to your e-mail\naddress on record in your account information, or by written communication sent\nby first class main or pre-paid mail to your address in your account\ninformation. Such notice shall be deemed to have been given upon the expiration\nof 48 hours after mailing or posting (if sent by first class mail or pre-paid\nmail) or 12 hours after sending (if sent by email). You may give notice to\nArcheMedX (such notice shall be deemed given when received by ArcheMedX) at\nanytime by letter sent by registered mail to: ArcheMedX, Inc, 300 E Main St\nSuite 101, Charlottesville, VA 22902.",
   :kyber.containers.terms-and-conditions/privacy
   "Privacy Policy: ArcheMedX’s Privacy Policy may be viewed at\nwww.archemedx.com. ArcheMedX reserves the right to modify its Privacy Policy\nat any time. Upon registration, users will have an opportunity to opt out of\nreceiving alerts and other non critical Application related communications\nfrom ArcheMedX. However as a hosted online, mobile or wireless application,\nArcheMedX may from time to time notify users (regardless of their opt out\nstatus) about the operation of the Application and user accounts.",
   :kyber.containers.terms-and-conditions/representations
   "Representations.  As a user of the Application, You are liable for the\naccuracy of the information that You provide to ArcheMedX, its partners and\nBusiness Associates, including, but not limited to, Your personal and\nprofessional representation as provided in the Section on Use. You hereby\ncertify that You do not have a financial interest in nor are You a paid\nconsultant acting on behalf of any entity, product or service that would benefit\nfrom the information you provide to this Site including, but not limited to,\nthe promotion of \"off-label\" drug uses, the disclosure of confidential\nclinical trial or other proprietary information.",
   :kyber.containers.terms-and-conditions/responsibilities
   "User Responsibilities. (a) Password and Security: You are solely\nresponsible for all activity occurring under your password or account used to\naccess the Application. You are solely responsible for maintaining the\nconfidentiality of your password and account, for ensuring that you exit from\nyour account at the end of each session, and for any loss, damages,\nconsequences, or other eventualities from any failure thereto. You are\nresponsible for notifying ArcheMedX immediately in the event of any\nunauthorized use of any password or account or any other known or suspected\nbreach of security. Neither ArcheMedX, nor any of its Licensors or Business\nAssociates are liable for any loss or damage arising from your failure to\ncomply with your responsibilities; (b) Account Information and Data: You are\nsolely responsible for all aspects of the information you submit (“Customer\nData”) in the course of registering for and using the Application. ArcheMedX\nis not responsible or liable for the loss, destruction, deletion or failure to\nstore any Customer Data",
   :kyber.containers.terms-and-conditions/rights
   "All rights not expressly granted to you are reserved by ArcheMedX and its\nLicensors. You may not (i) license, sublicense, post, sell, resell, transfer,\nassign, distribute or otherwise commercially exploit or make available to any\nthird party the website, Application, Technology or Content in any way; (ii)\nmodify, edit or copy the Application, Content or Technology; (iii) or make\nderivative works from the Application, Content or Technology. This license to\naccess the Site or, Application may not be shared or used by more than one\nindividual. ArcheMedX (together with its Licensors and Business Associates,\nwhere applicable) own all rights, titles and interests in and to all\nintellectual property related to the Site, Application, Technology, and\nContent. This Agreement does not convey to you any rights of ownership in the\nApplication, Content, Site or Technology. ArcheMedX reserves the right, at its\nsole discretion, to change, modify add or remove any portion of the Site or\nApplications, in whole or in part, at any time, whereupon you agree these Terms\nand Conditions and this Agreement remain in force.",
   :kyber.containers.terms-and-conditions/survival
   "Survival. The following provisions survive any termination or\nexpiration of this Agreement: This Section 19, Sections 4, 7, 11, 12, 13, 14,\n17, 18, 19, 20, 21 and 22.",
   :kyber.containers.terms-and-conditions/termination
   "Termination. Any breach or unauthorized use of the ArcheMedX\nApplication, the Site, or related ArcheMedX technology will be deemed a\nmaterial breach of this Agreement. ArcheMedX may, in its sole discretion, with\nor without notice to you, immediately terminate or suspend your password,\naccount or use of the Application if you breach or otherwise fail to comply\nwith this Agreement. In the event of a termination for material breach,\nArcheMedX shall have no obligation to retain Customer Data and may delete\nCustomer Data, without further notice to you. ArcheMedX may also in its sole\ndiscretion and at anytime discontinue providing the Site, the Application or\nany portion thereof, for any reason, with or without notice to you. You agree\nthat ArcheMedX shall not be liable to you for any termination of your access to\nthe Site, or Application.",
   :kyber.containers.terms-and-conditions/third-party-accreditation
   "Third Party Accreditation. You agree that ArcheMedX bears no\nresponsibility for any aspect of continuing medical education credits that may\nbe issued as a result of your use of the Application.",
   :kyber.containers.terms-and-conditions/third-party-interactions
   "Third Party Interactions, Affiliations, Co Branded Relationships.\nArcheMedX routinely works with third parties to provide the Application through\nvarious websites, mobile and wireless platforms “Wireless Platforms” and to\nprovide links to other websites (“Third Party Sites” and “Wireless Platforms”).\nThese Third Party Sites and Wireless Platforms may include accrediting bodies,\ncontent publishers, technology providers and Business Associates who may, in\nconjunction with ArcheMedX, provide a co-branded, or a “powered by” version of\nthe Application. These entities may supply information or content to the Site\nand the Application. ArcheMedX may provide links to Third Party Websites and\nWireless Platforms. These links are provided as a matter of convenience and\nArcheMedX does not endorse and has no control over the Third Party Sites or\nPlatforms. In no event shall ArcheMedX be liable for any damage or loss\nresulting from any use or reliance on any materials, content or Application\nprovided through such Third Party Sites or Platforms. You acknowledge and\nunderstand that certain Third Party Sites or Wireless Platforms may require\nyour agreement to additional or different terms and conditions and privacy\npolicies prior to your use of, or access to certain Applications, software or\nwebsites and that ArcheMedX bears no responsibility or liability in relation\nthereto. In the case of co-branded or” powered by” version of the Application,\nthe Business Associate’s terms and conditions and privacy policy may govern\nyour use of the co-branded or “powered by” version of the Application.",
   :kyber.containers.terms-and-conditions/waiver
   "Severability/Waiver. If any provision of these Terms and Conditions is\nheld by a court of competent jurisdiction to be unenforceable or invalid, the\nremainder of these Terms and Conditions shall continue in full force and effect.\nA failure by ArcheMedX to exercise or enforce any right or provision of these\nTerms and Conditions will not constitute or be deemed a waiver of such right\nor provision",
   :kyber.containers.terms-and-conditions/warranty
   "Disclaimer of Warranty. THIS SITE, THE APPLICATION AND ALL CONTENT, AND\nTECHNOLOGY ARE PROVIDED STRICTLY ON AN AS-IS BASIS. YOU USE THIS APPLICATION AT\nYOUR OWN RISK. YOU AGREE THAT NO WARRANTY OF MERCHANTABILITY; NO WARRANTY\nEXPRESS OR IMPLIED; NO WARRANTY OF FITNESS FOR ANY PURPOSE; AND NO GUARANTEE,\nEXISTS IN RELATION TO THE SITE, APPLICATION, WIRELESS PLATFORMS TECHNOLOGY OR\nCONTENT. YOU MUST EVALUATE THE INFORMATION CONTAINED WITHIN THIS SITE AND\nAPPLICATION AND MAKE YOUR OWN DETERMINATIONS BASED UPON YOUR PROFESSIONAL\nJUDGMENT. YOU AGREE AND ACKNOWLEDGE THAT CONTENT AND INFORMATION PROVIDED BY\nAND THROUGH THIS SITE AND APPLICATION ARE PROVIDED BY THIRD PARTIES AND THAT\nARCHEMEDX IS NOT RESPONSIBLE FOR SUCH CONTENT AND INFORMATION. YOU FURTHER\nACKNOWLEDGE AND ACCEPT THAT ARCHEMEDX DOES NOT REPRESENT OR WARRANT THAT (A)\nTHE USE OF THE APPLICATION WILL BE SECURE, TIMELY, UNINTERRUPTED OR ERROR FREE;\n(B) THE APPLICATION WILL MEET YOUR REQUIREMENT OR EXPECTATIONS; OR (C) ERRORS\nWILL BE CORRECTED.",
   :kyber.events.authentication/check-inbox
   "Please check your inbox. We’ve sent a confirmation email to the address entered. Please follow the steps in the email in order to proceed.",
   :kyber.events.authentication/could-not-save-changes
   "Could not save changes",
   :kyber.events.authentication/current-password-incorrect
   "Current password is incorrect.",
   :kyber.events.authentication/email-not-verified
   "Email is not verified",
   :kyber.events.authentication/password-not-saved
   "Password could not be saved",
   :kyber.events.authentication/password-updated "Password Updated",
   :kyber.events.authentication/resent-message
   "Your email has been resent",
   :kyber.events.authentication/reset-sent
   "A password reset email has been sent.",
   :kyber.events.authentication/send-another
   "Would you like us to send you another verification email?",
   :kyber.events.authentication/send-another-verification
   "Would you like us to send you another verification email?",
   :kyber.events.authentication/thanks-for-signing-up
   "Thank you for signing up!",
   :kyber.events.authentication/too-many-change-attempts
   "Too many password change attempts. Please try again later.",
   :kyber.events.authentication/verification-sent
   "A verification email has been sent.",
   :kyber.router/data-message "Please wait while we fetch your data",
   :kyber.utils/i18n-date->date-time-string
   (inst-fmt
    "{month-numeric-padded}/{day-padded}/{year} {hour12}:{minutes-padded} {dayperiod}"),
   :kyber.utils/model->cms-time-format
   (inst-fmt "{month-short} {day}, {year}"),
   :kyber.utils/model->cms-time-format-last-updated "Last updated: {1}",
   :kyber.utils/model->cms-time-format-no-date-time
   "No datetime information",
   :kyber.utils/moment-title-highlight "Your Annotation",
   :kyber.utils/moment-title-note "Educator Note",
   :kyber.utils/moment-title-question "Question",
   :kyber.utils/moment-title-text "Your Annotation",
   :kyber.utils/moment-title-timeline-user-note "Your Note",
   :learner.components.composite.active-moment/add-note "Add Note",
   :learner.components.composite.active-moment/continue "Continue",
   :learner.components.composite.active-moment/edit-note "Edit Note",
   :learner.components.composite.active-moment/page-number "Page {1}",
   :learner.components.composite.active-moment/skip "Skip for now",
   :learner.components.composite.active-moment/what-to-remember
   "What would you like to remember about this moment?",
   :learner.components.composite.active-moment-question-results/answer
   "Your Answer",
   :learner.components.composite.active-moment-question-results/chosen-correct-answer
   "Your Answer - Correct!",
   :learner.components.composite.active-moment-question-results/feedback
   "Educator Feedback",
   :learner.components.composite.active-moment-question-results/guessing
   "I'm Guessing",
   :learner.components.composite.active-moment-question-results/other-correct-answer
   "Correct Answer",
   :learner.components.composite.active-moment-question-results/peers-answered
   "How your peers answered:",
   :learner.components.composite.active-moment-question-results/all-collected-responses
   "All collected responses:",
   :learner.components.composite.active-moment-question-results/sure
   "I'm Sure",
   :learner.components.composite.active-moment-question-results/think
   "I Think",
   :learner.components.composite.active-whisper/view-resource
   "View Resource",
   :learner.components.composite.active-whisper/view-resources
   "View Resources",
   :learner.components.composite.activity-control-bar.core/adjust-playback
   "Adjust playback rate",
   :learner.components.composite.activity-control-bar.core/learning-stream
   "Learning Stream",
   :learner.components.composite.activity-control-bar.core/open-learning-stream
   "Open your Learning Stream",
   :learner.components.composite.activity-control-bar.core/rewind-15
   "Rewind 15 seconds",
   :learner.components.composite.activity-control-bar.moment-preview/educator-note
   "Educator Note",
   :learner.components.composite.activity-control-bar.moment-preview/learning-moment
   "Learning Moment",
   :learner.components.composite.activity-control-bar.moment-preview/note
   "Note",
   :learner.components.composite.activity-control-bar.moment-preview/question
   "Question",
   :learner.components.composite.activity-control-icons/continue-reading
   "CONTINUE READING",
   :learner.components.composite.activity-control-icons/editing-moment
   "You are currently editing a moment, please save your changes to continue with the activity.",
   :learner.components.composite.activity-control-icons/editing-resource
   "You are currently editing a resource, save your changes to continue with the video",
   :learner.components.composite.activity-control-icons/pending-changes
   "Pending Changes",
   :learner.components.composite.activity-control-icons/restart-video
   "RESTART VIDEO",
   :learner.components.composite.activity-control-icons/resume-video
   "RESUME VIDEO",
   :learner.components.composite.activity-digest.activity-notes/activity-notes
   "Your Activity Notes",
   :learner.components.composite.activity-digest.activity-notes/comment
   "Comment",
   :learner.components.composite.activity-digest.activity-notes/educator-note
   "Educator Note",
   :learner.components.composite.activity-digest.activity-notes/educator-question
   "Educator Question",
   :learner.components.composite.activity-digest.activity-notes/feedback
   "Educator Feedback",
   :learner.components.composite.activity-digest.activity-notes/no-notes
   "You didn't write any notes.",
   :learner.components.composite.activity-digest.activity-notes/page
   "Page {1}",
   :learner.components.composite.activity-digest.activity-notes/resource
   "Resource",
   :learner.components.composite.activity-digest.activity-notes/taken-at
   "Taken at {1}",
   :learner.components.composite.activity-digest.activity-notes/video-still
   "Video Still",
   :learner.components.composite.activity-digest.activity-notes/your-note
   "Your Note",
   :learner.components.composite.activity-digest.footer/archemedx
   "Powered By ArcheMedX",
   :learner.components.composite.activity-digest.objective-card/no-sections
   "No sections {1}",
   :learner.components.composite.activity-digest.objective-card/skipped
   "skipped",
   :learner.components.composite.activity-digest.objective-card/summary
   "You {verb} sections of the {resource-type} covering",
   :learner.components.composite.activity-digest.objective-card/viewed
   "viewed",
   :learner.components.composite.activity-digest.resource-card/no-description
   "No description provided.",
   :learner.components.composite.activity-pdf/activity-review
   "Next steps, visit activity review",
   :learner.components.composite.activity-pdf/curriculum
   "Next steps, visit curriculum",
   :learner.components.composite.activity-splash/begin-activity
   "Begin Activity",
   :learner.components.composite.activity-splash/moment-review-prompt
   "After reviewing this Learning Moment, you’ll be prompted to return to Review Mode.",
   :learner.components.composite.activity-splash/moment-review-visit
   "After you are done reviewing this moment, return to review mode by opening your learning stream and selecting Visit Activity Review.",
   :learner.components.composite.activity-splash/of "of",
   :learner.components.composite.activity-splash/page "Page",
   :learner.components.composite.activity-splash/page-progress
   "Page {start-page} of {end-page}",
   :learner.components.composite.activity-splash/page-segment
   "Page: {1}",
   :learner.components.composite.activity-splash/play "Play",
   :learner.components.composite.activity-splash/resume-where-you-left-off
   "Resume Where You Left Off",
   :learner.components.composite.activity-splash/review-learning-moment
   "Review Learning Moment",
   :learner.components.composite.activity-splash/start-at-the-beginning
   "Start At The Beginning",
   :learner.components.composite.activity-splash/start-video
   "START VIDEO",
   :learner.components.composite.activity-splash/view-document
   "View Document",
   :learner.components.composite.activity-splash/view-your-note
   "View Your Note",
   :learner.components.composite.activity-splash/what-would-you-like-to-do
   "What would you like to do?",
   :learner.components.composite.admin-link/view-in-admin
   "View in Admin",
   :learner.components.composite.bookmark-feed/no-content
   "You do not have any pinned content.",
   :learner.components.composite.bookmark-feed/note-screenshot
   "Note Screenshot",
   :learner.components.composite.bookmark-feed/open "Open",
   :learner.components.composite.bookmark-feed/play "Play",
   :learner.components.composite.bookmark-feed/view-in-doc
   "View In Document",
   :learner.components.composite.branded-navbar/account "Account",
   :learner.components.composite.branded-navbar/help "Help",
   :learner.components.composite.branded-navbar/home "Home",
   :learner.components.composite.cme-front-matter/view-info
   "View CME Information",
   :learner.components.composite.curriculum-banner/curriculum
   "CURRICULUM",
   :learner.components.composite.download-digest-button/download-digest
   "Download your Digest",
   :learner.components.composite.emphasized-banner/pay-attention
   "Please pay attention to this {1}",
   :learner.components.composite.highlighted-moment-preview/view-video
   "View Video",
   :learner.components.composite.leaderboard/activity-completion
   "Completed {completed} of {total-activities}",
   :learner.components.composite.leaderboard/avg-completion
   "Completed {average-learner-completion} of {total-activities}",
   :learner.components.composite.leaderboard/avg-progress
   "Average Curriculum Progress",
   :learner.components.composite.leaderboard/leaderboard "Leaderboard",
   :learner.components.composite.leaderboard/no-activity-completion
   "Completed 0 of {total-activities}",
   :learner.components.composite.leaderboard/no-other-learners
   "No other learners have participated in this curriculum yet.",
   :learner.components.composite.leaderboard/other-learners
   "Other Learners",
   :learner.components.composite.leaderboard/performance
   "Your Performance",
   :learner.components.composite.learning-stream-sidebar/end-of-document
   "END OF DOCUMENT",
   :learner.components.composite.learning-stream-sidebar/end-of-video
   "END OF VIDEO",
   :learner.components.composite.learning-stream-sidebar/help "Help",
   :learner.components.composite.learning-stream-sidebar/learning-stream
   "LEARNING STREAM",
   :learner.components.composite.learning-stream-sidebar/learning-stream-description
   "Within your Learning Stream you can access viewed Learning Moments and Educator Notes, as well as your personal notes, and any items that you have pinned for later.",
   :learner.components.composite.learning-stream-sidebar/learning-stream-importance
   "Your Learning Stream is important. Think of it as your personal helper.",
   :learner.components.composite.learning-stream-sidebar/notes "NOTES",
   :learner.components.composite.learning-stream-sidebar/pinned-content
   "PINNED CONTENT",
   :learner.components.composite.learning-stream-sidebar/resume-video
   "RESUME VIDEO",
   :learner.components.composite.learning-stream-sidebar/start-of-document
   "START OF DOCUMENT",
   :learner.components.composite.learning-stream-sidebar/start-of-video
   "START OF VIDEO",
   :learner.components.composite.learning-stream-sidebar/visit-activity-review
   "Visit Activity Review",
   :learner.components.composite.learning-stream-sidebar/visit-curriculum
   "Visit Curriculum",
   :learner.components.composite.learning-stream-sidebar/welcome-learning-stream
   "Welcome to your Learning Stream",
   :learner.components.composite.learning-stream.editing-states/moment-image
   "Moment Image",
   :learner.components.composite.learning-stream.editing-states/question
   "Question",
   :learner.components.composite.learning-stream.editing-states/video-still
   "Video Still",
   :learner.components.composite.learning-stream.editing-states/what-to-remember
   "What would you like to remember about this moment?",
   :learner.components.composite.learning-stream.expanded-states/empty-note-list
   "No note to show. If you add one, it'll show up here.",
   :learner.components.composite.learning-stream.expanded-states/moment-img
   "Moment Image",
   :learner.components.composite.learning-stream.expanded-states/video-still
   "Video Still",
   :learner.components.composite.learning-stream.expanded-states/what-to-remember
   "What would you like to remember about this moment?",
   :learner.components.composite.learning-stream.preview-states/empty-notes
   "No note to show. If you add one, it'll show up here.",
   :learner.components.composite.learning-stream.preview-states/resource-preview
   "Resource preview",
   :learner.components.composite.learning-stream.shared/add-note
   "Add Note",
   :learner.components.composite.learning-stream.shared/answer-later
   "Answer Later",
   :learner.components.composite.learning-stream.shared/answer-question
   "Answer Question",
   :learner.components.composite.learning-stream.shared/continue
   "Continue",
   :learner.components.composite.learning-stream.shared/edit-note
   "Edit Note",
   :learner.components.composite.learning-stream.shared/moment-type-and-author
   (icu/msg
    "{author, select, educator {Educator } other {Your }} {momentType}"),
   :learner.components.composite.learning-stream.shared/page-number
   "Page {1}",
   :learner.components.composite.learning-stream.shared/page-number-colon
   "Page: {1}",
   :learner.components.composite.learning-stream.shared/play-btn-copy
   "Play",
   :learner.components.composite.learning-stream.shared/play-in-video
   "Play in Video",
   :learner.components.composite.learning-stream.shared/question-moment
   (icu/msg
    "{momentType, select, question {Question} other {{momentTitle}}}"),
   :learner.components.composite.learning-stream.shared/review-later
   "Review Later",
   :learner.components.composite.learning-stream.shared/view-btn-copy
   "View in document",
   :learner.components.composite.learning-stream.shared/view-in-pdf
   "View in PDF",
   :learner.components.composite.navbar/logo "{partner-name} Logo",
   :learner.components.composite.notepad/add-note "Add A Note",
   :learner.components.composite.notepad/add-video-still
   "Add Video Still",
   :learner.components.composite.notepad/remember-moment
   "What would you like to remember about this moment?",
   :learner.components.composite.notepad/remove-video-still
   "Remove Video Still",
   :learner.components.composite.notepad/screenshot-alt "Screenshot",
   :learner.components.composite.notes-feed/no-notes
   "You do not have any notes.",
   :learner.components.composite.notes-feed/recently-updated-notes
   "Recently updated notes are displayed first",
   :learner.components.composite.questionnaire.active-question/optional-or-required
   (icu/msg "({isRequired, select, true {required} other {optional}})"),
   :learner.components.composite.questionnaire.active-question/question-number
   "Question {1}",
   :learner.components.composite.questionnaire.questionnaire-submit/answer-to-submit
   "In order to submit, please go back and answer all required questions.",
   :learner.components.composite.questionnaire.questionnaire-submit/evaluation
   "Evaluation",
   :learner.components.composite.questionnaire.questionnaire-submit/missed-something
   "Looks like you missed something.",
   :learner.components.composite.questionnaire.questionnaire-submit/post-test
   "Post-Test",
   :learner.components.composite.questionnaire.questionnaire-submit/pre-test
   "Pre-Test",
   :learner.components.composite.questionnaire.questionnaire-submit/question-number
   "Question {1}",
   :learner.components.composite.questionnaire.questionnaire-submit/questionnaire
   "Questionnaire",
   :learner.components.composite.questionnaire.questionnaire-submit/ready-to-submit
   "Ready to Submit?",
   :learner.components.composite.questionnaire.questionnaire-submit/required
   "(Required)",
   :learner.components.composite.questionnaire.questionnaire-submit/submit
   "Submit",
   :learner.components.composite.questionnaire.questionnaire-submit/submit-or-answer
   "Submit, or answer any of the skipped optional questions shown below.",
   :learner.components.composite.questionnaire.questionnaire-submit/submit-or-review
   "Submit, or if you'd like to review your answers you can navigate back to any question using the tabs above.",
   :learner.components.composite.questionnaire.results/additional-resources
   "Additional Resources",
   :learner.components.composite.questionnaire.results/back-to-review
   "Back to Activity Review",
   :learner.components.composite.questionnaire.results/continue-to-activity
   "Continue to Activity",
   :learner.components.composite.questionnaire.results/correct "Correct",
   :learner.components.composite.questionnaire.results/correct-answer
   "Correct Answer",
   :learner.components.composite.questionnaire.results/educator-feedback
   "Educator Feedback",
   :learner.components.composite.questionnaire.results/get-credit
   "Get Credit",
   :learner.components.composite.questionnaire.results/go-home "Go Home",
   :learner.components.composite.questionnaire.results/graded-summary
   "You answered {1} out of {2} graded questions correctly.",
   :learner.components.composite.questionnaire.results/guess
   "I'm Guessing",
   :learner.components.composite.questionnaire.results/incorrect
   "Incorrect",
   :learner.components.composite.questionnaire.results/na "N/A",
   :learner.components.composite.questionnaire.results/no-answer
   "No answer given",
   :learner.components.composite.questionnaire.results/or "or",
   :learner.components.composite.questionnaire.results/participation-thanks
   "Thank you for participating in the questionnaire.",
   :learner.components.composite.questionnaire.results/post-test
   "Post-Test",
   :learner.components.composite.questionnaire.results/pre-test
   "Pre-Test",
   :learner.components.composite.questionnaire.results/question-number
   "Question {1}",
   :learner.components.composite.questionnaire.results/questionnaire
   "Questionnaire",
   :learner.components.composite.questionnaire.results/restart-post-test
   "Restart Post-Test",
   :learner.components.composite.questionnaire.results/attempts-exhausted
   "No More Attempts Available",
   :learner.components.composite.questionnaire.results/restart-questionnaire
   "Restart Questionnaire",
   :learner.components.composite.questionnaire.results/results "Results",
   :learner.components.composite.questionnaire.results/review-or-post-test
   "We recommend you return to the Activity Review, or you can restart the Post-Test now.",
   :learner.components.composite.questionnaire.results/review-or-questionnaire
   "We recommend you return to the Activity Review, or you can restart the questionnaire now.",
   :learner.components.composite.questionnaire.results/review-only-attempts-exhausted
   "We recommend you return to the Activity Review.",
   :learner.components.composite.questionnaire.results/submit-thanks
   "Thank you for submitting the evaluation.",
   :learner.components.composite.questionnaire.results/sure "I'm Sure",
   :learner.components.composite.questionnaire.results/take-evaluation
   "Take Evaluation",
   :learner.components.composite.questionnaire.results/tested-out
   "You don’t need to take this activity, based on your pre-test performance",
   :learner.components.composite.questionnaire.results/unsure "I Think",
   :learner.components.composite.questionnaire.results/view-curriculum
   "View Curriculum",
   :learner.components.composite.questionnaire.results/you-passed
   "You Passed",
   :learner.components.composite.questionnaire.results/your "Your",
   :learner.components.composite.questionnaire.results/your-answer
   "Your Answer",
   :learner.components.composite.questionnaire.results/your-confidence
   "Your Confidence:",
   :learner.components.composite.questionnaire.tab-navigation/answer-questions
   "Please answer the following questions.",
   :learner.components.composite.questionnaire.tab-navigation/submit
   "Submit",
   :learner.components.composite.resource-library/enter-search-term
   "Enter Search Term",
   :learner.components.composite.resource-library/resource-library
   "Resource Library",
   :learner.components.composite.resource-library/show-featured
   "Show Featured Only",
   :learner.components.composite.resource-list/download-resource
   "Download resource",
   :learner.components.composite.resource-list/paginated-resources
   "Showing 1 to {paginated-resources} of {resources}",
   :learner.components.composite.resource-list/processing
   "{name}  (processing)",
   :learner.components.composite.resource-list/view-more "View More",
   :learner.components.composite.resource-viewer/add-note
   "Add Your Note",
   :learner.components.composite.resource-viewer/details "Details",
   :learner.components.composite.resource-viewer/download-resource
   "Download resource",
   :learner.components.composite.review-mode-buffering/personalizing-activity-review
   "Personalizing your Activity Review…",
   :learner.components.composite.searchable-resource-list/featured-empty-copy
   (icu/msg
    "{displayedResultsCount} {featured, select, true { Featured} other {}}{resourceCopy}"),
   :learner.components.composite.searchable-resource-list/no-results
   "No Results",
   :learner.components.composite.searchable-resource-list/relates-plural
   " Relates",
   :learner.components.composite.searchable-resource-list/relates-singular
   " Relate",
   :learner.components.composite.searchable-resource-list/render-results-catchall
   (icu/msg
    "{displayedResultsCount} {featured, select, true { Featured} other {}}{resourceCopy}{relateCopy} to '{searchTerm}'"),
   :learner.components.composite.searchable-resource-list/resource-plural
   " Resources",
   :learner.components.composite.searchable-resource-list/resource-singular
   " Resource ",
   :learner.components.composite.searchable-resource-list/searching
   "Searching...",
   :learner.components.composite.take-note-button/add-note "Add Note",
   :learner.components.composite.user-information-requirements/before-proceeding
   "Before you proceed, please fill in the following:",
   :learner.components.composite.user-information-requirements/continue
   "Continue",
   :learner.components.composite.user-information-requirements/first-name
   "First Name",
   :learner.components.composite.user-information-requirements/last-name
   "Last Name",
   :learner.components.composite.user-information-requirements/required
   "Required",
   :learner.components.composite.user-menu/change "Change",
   :learner.components.composite.user-menu/help "Help",
   :learner.components.composite.user-menu/sign-out "Sign Out",
   :learner.components.composite.user-menu/signed-in-as "Signed in as:",
   :learner.components.composite.user-menu/unspecified "Unspecified",
   :learner.components.composite.user-note/attached-to "Attached to",
   :learner.components.composite.user-note/attached-to-annotation
   "Attached to Annotation",
   :learner.components.composite.user-note/attached-to-resource
   "Attached to Resource",
   :learner.components.composite.user-note/edit-note "Edit Note",
   :learner.components.composite.user-note/open "Open",
   :learner.components.composite.user-note/page-number "Page: {1}",
   :learner.components.composite.user-note/resource-not-found
   "Resource cannot be found",
   :learner.components.composite.user-note/taken-at "Taken at",
   :learner.components.composite.user-note/updated "Updated",
   :learner.components.composite.user-note/video-still "Video Still",
   :learner.components.composite.user-note/view-in-document
   "View in Document",
   :learner.components.composite.user-note/view-in-video "View in Video",
   :learner.components.composite.user-note/view-moment "View Moment",
   :learner.components.composite.user-note/your-note "Your Note",
   :learner.components.forms.active-questionnaire-question/answer-below
   "Answer the question below this image",
   :learner.components.forms.active-questionnaire-question/skip-for-now
   "Skip for now",
   :learner.components.forms.fields.binary-answer/false "False",
   :learner.components.forms.fields.binary-answer/true "True",
   :learner.components.forms.fields.rating-scale-question/na "N/A",
   :learner.components.forms.note/cancel "Cancel",
   :learner.components.forms.note/delete "Delete",
   :learner.components.forms.note/delete-alert
   "Are you sure you want to delete your note?",
   :learner.components.forms.note/delete-note "Delete Note",
   :learner.components.forms.note/ignore-changes "Ignore Changes",
   :learner.components.forms.note/pending-changes "Pending Changes",
   :learner.components.forms.note/placeholder
   "Capture your thoughts here...",
   :learner.components.forms.note/return-to-note "Return To Note",
   :learner.components.forms.note/save-and-continue "Save and Continue",
   :learner.components.forms.note/save-note "Save Note",
   :learner.components.forms.note/unsaved-alert
   "You have unsaved changes. Are you sure you want to close your note?",
   :learner.components.forms.note/update "Update",
   :learner.components.forms.question-base/enter-answer
   "Enter your answer here...",
   :learner.components.forms.question-base/guessing "I'm Guessing",
   :learner.components.forms.question-base/how-confident
   "How confident are you in your answer?",
   :learner.components.forms.question-base/next "Next",
   :learner.components.forms.question-base/required "Required",
   :learner.components.forms.question-base/save "Save",
   :learner.components.forms.question-base/sure "I'm Sure",
   :learner.components.forms.question-base/think "I Think",
   :learner.components.forms.question-base/validate-count
   "Please answer the entire question before continuing.",
   :learner.components.forms.question-base/validate-empty
   "Choice cannot be empty.",
   :learner.containers.activity/intro-activity-msg
   "Taking you to your curriculum",
   :learner.containers.activity/media-not-supported
   "Media Type Not Supported",
   :learner.containers.activity-digest/comprehended "comprehended",
   :learner.containers.activity-digest/digest "digest",
   :learner.containers.activity-digest/learning-objective-performance
   "Learning Objective Performance",
   :learner.containers.activity-digest/my-activity-digest
   (icu/msg
    "{hasName, select, true {{name}'s Activity Digest} other {Activity Digest}}"),
   :learner.containers.activity-digest/no-pinned-content
   "You didn't pin any content.",
   :learner.containers.activity-digest/overlooked "overlooked",
   :learner.containers.activity-digest/performance-moment-body
   "Successful learners engage in at least 80%",
   :learner.containers.activity-digest/performance-moment-description
   "of learning moments engaged",
   :learner.containers.activity-digest/performance-notes-body
   "Successful learners have at least 6",
   :learner.containers.activity-digest/performance-notes-description
   "Notes and Pins",
   :learner.containers.activity-digest/performance-percent-body
   (icu/msg
    "Successful learners {isPDF, select, true {read} other {watch}} at least 88%"),
   :learner.containers.activity-digest/performance-percent-description
   (icu/msg
    "of {isPDF, select, true {document read} other {video watched}}"),
   :learner.containers.activity-digest/performance-user-annotations-body
   "Successful learners have at least 4",
   :learner.containers.activity-digest/performance-user-annotations-description
   "Highlights and Comments",
   :learner.containers.activity-digest/recommended-resources
   "Recommended Resources",
   :learner.containers.activity-digest/your-activity-performance
   "Your Activity Performance",
   :learner.containers.activity-digest/your-pinned-content
   "Your Pinned Content",
   :learner.containers.activity-questionnaire/continue-evaluation
   "Continue Evaluation",
   :learner.containers.activity-questionnaire/continue-floating
   "Continue",
   :learner.containers.activity-questionnaire/continue-post-test
   "Continue Post-Test",
   :learner.containers.activity-questionnaire/continue-pre-test
   "Continue Pre-Test",
   :learner.containers.activity-questionnaire/evaluation-contains-results-false
   "Please begin the Evaluation.",
   :learner.containers.activity-questionnaire/evaluation-contains-results-true
   "Please finish the Evaluation.",
   :learner.containers.activity-questionnaire/floating-contains-results-false
   "Please click \"Start\" to begin.",
   :learner.containers.activity-questionnaire/floating-contains-results-true
   "Please click \"Continue\" to resume.",
   :learner.containers.activity-questionnaire/post-test-contains-results-false
   "Please begin the Post-Test.",
   :learner.containers.activity-questionnaire/post-test-contains-results-true
   "Please finish the Post-Test.",
   :learner.containers.activity-questionnaire/pre-test-contains-results-false
   "Please take the Pre-Test before beginning this activity.",
   :learner.containers.activity-questionnaire/pre-test-contains-results-true
   "Please finish the Pre-Test before beginning this activity.",
   :learner.containers.activity-questionnaire/start-evaluation
   "Start Evaluation",
   :learner.containers.activity-questionnaire/start-floating "Start",
   :learner.containers.activity-questionnaire/start-post-test
   "Start Post-Test",
   :learner.containers.activity-questionnaire/start-pre-test
   "Start Pre-Test",
   :learner.containers.activity-readiness-mindset-tool/above-learning-action-threshold
   "Above Learning Action Threshold",
   :learner.containers.activity-readiness-mindset-tool/above-post-test-reflective-threshold
   "Above Post-Test Reflective Threshold",
   :learner.containers.activity-readiness-mindset-tool/above-pre-test-reflective-threshold
   "Above Pre-Test Reflective Threshold",
   :learner.containers.activity-readiness-mindset-tool/above-scrubbed-backwards-threshold
   "Above Scrubbed Backwards Threshold",
   :learner.containers.activity-readiness-mindset-tool/assessment-analysis
   "Assessment Analysis",
   :learner.containers.activity-readiness-mindset-tool/below-learning-action-threshold
   "Below Learning Action Threshold?",
   :learner.containers.activity-readiness-mindset-tool/below-time-to-complete
   "Below Time to Complete?",
   :learner.containers.activity-readiness-mindset-tool/date-started
   "Date Started: ",
   :learner.containers.activity-readiness-mindset-tool/false "False",
   :learner.containers.activity-readiness-mindset-tool/fetch-latest-session-data
   "Fetch Latest Session Data",
   :learner.containers.activity-readiness-mindset-tool/first-post-test-mastery-score
   "First Post-Test Mastery Score",
   :learner.containers.activity-readiness-mindset-tool/first-pre-test-mastery-score
   "First Pre-Test Mastery Score",
   :learner.containers.activity-readiness-mindset-tool/first-viewed-review-mode
   "First Viewed Review Mode",
   :learner.containers.activity-readiness-mindset-tool/high-mindset-flags
   "High Mindset Flags",
   :learner.containers.activity-readiness-mindset-tool/high-mindset-score
   "High Mindset Score",
   :learner.containers.activity-readiness-mindset-tool/learning-action-count
   "Learning Action Count",
   :learner.containers.activity-readiness-mindset-tool/low-mindset-flags
   "Low Mindset Flags",
   :learner.containers.activity-readiness-mindset-tool/low-mindset-score
   "Low Mindset Score",
   :learner.containers.activity-readiness-mindset-tool/mastery-analysis
   "Mastery Analysis",
   :learner.containers.activity-readiness-mindset-tool/meets-high-mindset
   "Meets High Mindset?",
   :learner.containers.activity-readiness-mindset-tool/meets-low-mindset
   "Meets Low Mindset?",
   :learner.containers.activity-readiness-mindset-tool/mindset "Mindset",
   :learner.containers.activity-readiness-mindset-tool/mindset-analysis
   "Mindset Analysis",
   :learner.containers.activity-readiness-mindset-tool/mindset-data
   "Mindset Data",
   :learner.containers.activity-readiness-mindset-tool/no-post-test-reflection
   "No Post-Test Reflection?",
   :learner.containers.activity-readiness-mindset-tool/not-set "Not Set",
   :learner.containers.activity-readiness-mindset-tool/not-set-hyphenated
   "not-set",
   :learner.containers.activity-readiness-mindset-tool/not-started
   "not-started",
   :learner.containers.activity-readiness-mindset-tool/not-viewed
   "Not viewed",
   :learner.containers.activity-readiness-mindset-tool/plo-analysis
   "PLO Analysis",
   :learner.containers.activity-readiness-mindset-tool/plo-consumed
   "PLO Consumed?",
   :learner.containers.activity-readiness-mindset-tool/plo-not-consumed
   "PLO Not Consumed?",
   :learner.containers.activity-readiness-mindset-tool/plo-percent-consumed
   "PLO Percent Consumed",
   :learner.containers.activity-readiness-mindset-tool/post-test-reflective-count
   "Post-Test Reflective Count",
   :learner.containers.activity-readiness-mindset-tool/post-test-reflective-threshold
   "Post-Test Reflective Threshold",
   :learner.containers.activity-readiness-mindset-tool/pre-test-reflective-count
   "Pre-Test Reflective Count",
   :learner.containers.activity-readiness-mindset-tool/pre-test-reflective-threshold
   "Pre-Test Reflective Threshold",
   :learner.containers.activity-readiness-mindset-tool/readiness
   "Readiness",
   :learner.containers.activity-readiness-mindset-tool/revisited-moments
   "Revisited Moments?",
   :learner.containers.activity-readiness-mindset-tool/tenuous-mastery-score
   "Tenuous Mastery Score",
   :learner.containers.activity-readiness-mindset-tool/tenuous-mastery-score-penalty
   "Tenuous Mastery Score Penalty",
   :learner.containers.activity-readiness-mindset-tool/time-to-complete
   "Time to complete (hh:mm:ss)",
   :learner.containers.activity-readiness-mindset-tool/true "True",
   :learner.containers.activity-results/activity-review-for
   (icu/msg
    "Activity Review{someGivenName, select, true { for {givenName}} other {}}"),
   :learner.containers.activity-results/activity-stat-consumption "{1}%",
   :learner.containers.activity-results/activity-stat-engaged "{1}%",
   :learner.containers.activity-results/activity-stat-learning-action-details
   "Successful learners have at least 6",
   :learner.containers.activity-results/activity-stat-learning-action-title
   (icu/msg
    "You have {learningActionCount, plural, =1 {# Note or Pin} other {# Notes and Pins}}"),
   :learner.containers.activity-results/activity-stat-moment-details
   "Successful learners engage in at least 80%",
   :learner.containers.activity-results/activity-stat-moment-title
   "You engaged in {1}% of Learning Moments",
   :learner.containers.activity-results/activity-stat-read-details
   "Successful learners read at least 88%",
   :learner.containers.activity-results/activity-stat-read-title
   "You read {1}% of the document",
   :learner.containers.activity-results/activity-stat-user-annotation-details
   "Successful learners have at least 4",
   :learner.containers.activity-results/activity-stat-user-annotation-title
   (icu/msg
    "You have {userAnnotationCount, plural, =1 {# Highlight or Comment} other {# Highlights and Comments}}"),
   :learner.containers.activity-results/activity-stat-watched-details
   "Successful learners watched at least 88%",
   :learner.containers.activity-results/activity-stat-watched-title
   "You watched {1}% of the video",
   :learner.containers.activity-results/claim-credit
   "Be sure to claim your credit.",
   :learner.containers.activity-results/completed-activity
   "You have completed this Activity",
   :learner.containers.activity-results/completed-activity-content
   "You have finished the learning content for this Activity",
   :learner.containers.activity-results/download-digest
   "Download your Digest",
   :learner.containers.activity-results/evaluation-label "Evaluation",
   :learner.containers.activity-results/get-credit "Get Credit",
   :learner.containers.activity-results/go-home "Go Home",
   :learner.containers.activity-results/learner-engaged-pdf-btn
   "View In Document",
   :learner.containers.activity-results/learner-engaged-video-btn "Play",
   :learner.containers.activity-results/learning-objective
   "Learning Objective",
   :learner.containers.activity-results/lo-bookmark-amount
   (icu/msg "{bmCount, plural, =1 {# Pin} other {# Pins}}"),
   :learner.containers.activity-results/lo-note-amount
   (icu/msg "{noteCount, plural, =1 {# Note} other {# Notes}}"),
   :learner.containers.activity-results/moment-snapshot-alt
   "Moment Snapshot",
   :learner.containers.activity-results/no-notes
   "You do not have any notes.",
   :learner.containers.activity-results/no-resources-for-lo
   "No related resources for this learning objective.",
   :learner.containers.activity-results/notes-sorted-by
   "Notes are sorted by time last updated",
   :learner.containers.activity-results/open-link "Open ",
   :learner.containers.activity-results/open-resource-lib
   "Open Resource Library",
   :learner.containers.activity-results/pdf-page "Page: {1}",
   :learner.containers.activity-results/please-proceed
   "Please proceed to the {next-step}",
   :learner.containers.activity-results/please-proceed-when-ready
   "Please proceed to the {next-step} when ready.",
   :learner.containers.activity-results/please-review-pill
   "Please Review",
   :learner.containers.activity-results/please-review-recommendations
   "Please review your recommendations below.",
   :learner.containers.activity-results/activity-review-scroll-message
   "Scroll down to view your engagement scores and optional recommendations to boost your learning",
   :learner.containers.activity-results/activity-review-optional-message
   "The engagement scores and recommendations below are suggestions to improve your learning. You may proceed to the Post-Test whenever you feel ready.",
   :learner.containers.activity-results/post-test-button-review
   "Review Post-Test",
   :learner.containers.activity-results/post-test-button-take
   "Take Post-Test",
   :learner.containers.activity-results/post-test-learning-objectives-engagement
   "You were highly engaged with {1} of {2} Learning Objectives.",
   :learner.containers.activity-results/post-test-label "Post-Test",
   :learner.containers.activity-results/related-learning-moments
   "Related Learning Moments",
   :learner.containers.activity-results/related-resources
   "Related Resources",
   :learner.containers.activity-results/review-actions
   "Please review any recommended actions for each learning objective.",
   :learner.containers.activity-results/review-label "Review",
   :learner.containers.activity-results/review-notes-below
   "Review your notes below.",
   :learner.containers.activity-results/revisit
   (icu/msg
    "You can revisit the Activity{postTestExists, select, true {, or review your Post-Test performance} other {}}"),
   :learner.containers.activity-results/revisit-activity-btn
   "Revisit Activity",
   :learner.containers.activity-results/take-evaluation-btn
   "Take Evaluation",
   :learner.containers.activity-results/video-time-concat
   "{start-time-string} - {end-time-string}",
   :learner.containers.activity-results/your-notes "Your Notes",
   :learner.containers.activity-results/your-pins "Your Pinned Content",
   :learner.containers.activity-results/your-recs "Your Recommendations",
   :learner.containers.curriculum/activities "Activities",
   :learner.containers.curriculum/activity " activity",
   :learner.containers.curriculum/all-resources "All Resources",
   :learner.containers.curriculum/curriculum-complete-text
   "All necessary steps have been completed for this curriculum",
   :learner.containers.curriculum/curriculum-complete-title
   "Curriculum Complete!",
   :learner.containers.curriculum/curriculum-signing-button "Sign Curriculum",
   :learner.containers.curriculum/curriculum-signing-button-sending "Sending...",
   :learner.containers.curriculum/curriculum-signing-signed "Signed",
   :learner.containers.curriculum/curriculum-signing-ready-title "Ready to sign",
   :learner.containers.curriculum/curriculum-signing-ready-subtitle "All activities completed",
   :learner.containers.curriculum/curriculum-signing-signed-and-eligible-subtitle "You may e-sign a new training record that includes newly completed activities",
   :curriculum-signing-instructions/title "Next steps to electronically sign",
   :curriculum-signing-instructions/check-your-email "Check Your Email",
   :curriculum-signing-instructions/email-sent-confirmation "We've sent you an email with detailed instructions and your unique signature code. Please check your inbox and follow the instructions to complete your digital signature.",
   :curriculum-signing-instructions/support-info "If you don't see the email, check your spam folder or contact support.",
   :curriculum-signing-instructions/go-home "Go Home",
   :curriculum-signing-instructions/error-title "Instructions Unavailable",
   :curriculum-signing-instructions/error-subtitle "Signing Instructions Not Available",
   :curriculum-signing-instructions/error-message "Digital signature instructions are not available at this time. This may be because signing is not enabled for this curriculum or you are not eligible to sign. Check your curriculum to see if you have completed all activities.",
   :curriculum-signing-instructions/return-to-curriculum "Return to Curriculum",
   :curriculum-signing-instructions/already-signed-title "You have already signed",
   :curriculum-signing-instructions/already-signed-subtitle "Signature Complete",
   :curriculum-signing-instructions/already-signed-message "You have already completed the digital signature for this curriculum.",
   :learner.containers.curriculum/draft "DRAFT",
   :learner.containers.curriculum/featured-resources
   "Featured Resources",
   :learner.containers.curriculum/intro "Introduction ",
   :learner.containers.curriculum/matching-resources
   "Matching Resources",
   :learner.containers.curriculum/online-curriculum "Online Curriculum",
   :learner.containers.curriculum/pdf "PDF",
   :learner.containers.curriculum/published "PUBLISHED",
   :learner.containers.curriculum/resource-library "Resource Library",
   :learner.containers.curriculum/resume "Resume",
   :learner.containers.curriculum/review "Review",
   :learner.containers.curriculum/revisit "Revisit",
   :learner.containers.curriculum/start "Start",
   :learner.containers.curriculum/loading "Loading",
   :learner.containers.curriculum/supplemental-activities
   "Optional Activities",
   :learner.containers.curriculum/take-evaluation "Take Evaluation",
   :learner.containers.curriculum/take-post-test "Take Post-Test",
   :learner.containers.curriculum/test-out-msg
   "Not required based on your pre-test performance",
   :learner.containers.curriculum/video "Video",
   :learner.containers.curriculum-registration/additional-info
   "Additional Information",
   :learner.containers.curriculum-registration/cancel "Cancel",
   :learner.containers.curriculum-registration/continue "Continue",
   :learner.containers.curriculum-registration/fill-in
   "Before you proceed, please fill in the following:",
   :learner.containers.curriculum-registration/first-name "First Name",
   :learner.containers.curriculum-registration/last-name "Last Name",
   :learner.containers.curriculum-registration/participant-id "Participant ID",
   :learner.containers.curriculum-registration/required "Required",
   :learner.containers.curriculum-registration/select-tag-group
   "Select a {1}",
   :learner.containers.curriculum-registration/update "Update",
   :learner.containers.curriculum-registration/update-info
   "Update your curriculum information:",
   :learner.containers.curriculum-sign-in/sign-in "Sign In",
   :learner.components.composite.curriculum-banner/download-certificate "Download Certificate",
   :learner.containers.curriculum-signature/banner-title "Attestation of Training Completion",
   :learner.containers.curriculum-signature/page-title "Sign to complete your training",
   :learner.containers.curriculum-signature/page-subtitle "Review the record below, then enter your signature code to apply your electronic signature.",
   :learner.containers.curriculum-signature/awaiting-signature "Awaiting signature",
   :learner.containers.curriculum-signature/attestation-docs "You are attesting that you have completed the following:",
   :learner.containers.curriculum-signature/apply-signature-label "Apply your e-signature — enter your signature code",
   :learner.containers.curriculum-signature/paste-helper "Paste your full code into the first box, or type each character.",
   :learner.containers.curriculum-signature/consent-note "Entering your signature code applies your electronic signature to the attestation above.",
   :learner.containers.curriculum-signature/sign-note "Your signature will be recorded with the date and time you apply it.",
   :learner.containers.curriculum-signature/signature-attempts-exhausted "You have exhausted all signature attempts. Please contact your administrator.",
   :learner.containers.curriculum-signature/expired-code "Your signature code has expired. Please return to the Curriculum home page to generate another code.",
   :learner.containers.curriculum-signature/code-already-used "Your signature code has already been used. Please contact your administrator if you believe this is an error.",
   :learner.containers.curriculum-signature/signature-attempts-remaining "Signature code incorrect. You have {1} attempt(s) remaining.",
   :learner.containers.curriculum-signature/submit "Sign",
   :learner.containers.curriculum-signature-confirmation/banner-title "Training Completion Confirmation",
   :learner.containers.curriculum-signature-confirmation/completed-training "has completed all required training for the curriculum",
   :learner.containers.curriculum-signature-confirmation/signed-label "Signed",
   :learner.containers.curriculum-signature-confirmation/activities-completed "Activities completed",
   :learner.containers.curriculum-signature-confirmation/scroll-hint "Scroll to see all {1} activities",
   :learner.containers.curriculum-signature-confirmation/signed-by "signed electronically by",
   :learner.containers.curriculum-signature-confirmation/download-certificate "Download certificate",
   :learner.containers.curriculum-signature-confirmation/congratulations "Congratulations — you're all done! You can close this tab.",
   :learner.containers.curriculum-signature-confirmation/record-stored "A copy of this record is stored with your training history.",
   :learner.containers.curriculum-signature-confirmation/e-sig-logged "Your e-signature has been received. You may download your training certificate above, or from the Curriculum home page at any time.",
   :learner.containers.curriculum-signature-confirmation/go-to-curriculum "Go to Curriculum",
   :learner.containers.invalid-curriculum-signature/banner-title "Your link expired",
   :learner.containers.invalid-curriculum-signature/message "Please return to the Curriculum page to request a new code.",
   :learner.containers.download-digest/click-to-download
   "Click on the link below to download your digest",
   :learner.containers.profile/about-you "About You",
   :learner.containers.profile/account-overview "Account Overview",
   :learner.containers.profile/back-to-activity "Back to Activity",
   :learner.containers.profile/email "Email",
   :learner.containers.profile/email-benefits
   "Emails that are sent will help improve and augment the overall learning experience.",
   :learner.containers.profile/email-permanence
   "The email address associated with your account cannot be changed.",
   :learner.containers.profile/email-preferences "Email Preferences",
   :learner.containers.profile/email-unsubscribe
   "Unsubscribe from all emails",
   :learner.containers.profile/sign-out "Sign out",
   :learner.events.activity/create-note-success-learning-stream
   "Learning Stream",
   :learner.events.activity/create-note-success-note "Notes tab",
   :learner.events.activity/create-note-success-predicate
   "Your note has been saved to the ",
   :learner.events.activity/delete-note-success-msg "Note deleted!",
   :learner.events.activity/pin-failure-msg
   "Content could not be pinned",
   :learner.events.activity/pin-success-msg "Pinned",
   :learner.events.activity/unpin-failure-msg "Could not remove pin",
   :learner.events.activity/unpin-success-msg "Pin removed",
   :learner.events.curriculum-signing/email-send-failed
   "Failed to send signing email. Please try again.",


   :learner.events.activity/update-note-success-msg "Note updated!",
   :learner.events.questionnaire/get-questionnaire-failure-msg-body
   "On no! Looks like we couldn't find the questionnaire you're looking for.",
   :learner.events.questionnaire/get-questionnaire-failure-msg-confirm
   "Review Mode",
   :learner.events.questionnaire/get-questionnaire-failure-msg-title
   "Questionnaire Not Found",
   :learner.events.questionnaire/question-response-failure-msg
   "Something went wrong! Please try to submit again.",
   :learner.router.core/activity-loading-msg
   "Please wait while we build your activity",
   :learner.router.core/activity-registration-loading-msg
   "Please wait while we gather your registration",
   :learner.router.core/curriculum-loading-msg
   "Please wait while we gather your activities",
   :learner.router.core/curriculum-registration-loading-msg
   "Please wait while we gather your registration",
   :pathom.mutations.curriculum.signatures.email/button,
   "Complete Signing"
   :pathom.mutations.curriculum.signatures.email/subject-with-title "Action Required: Signature Code for {1}"
   :pathom.mutations.curriculum.signatures.email/subject-no-title "Action Required: Your Training Signature Code"
   :pathom.mutations.curriculum.signatures.email/ignore "If you did not initiate this signing request, please disregard this email or contact your administrator."
   :pathom.mutations.curriculum.signatures.email/display-name "Archemedx"
   :pathom.mutations.curriculum.signatures.email/intro-with-title "You are required to digitally sign {curriculumTitle}. Please follow the instructions below to complete your electronic signature."
   :pathom.mutations.curriculum.signatures.email/intro-no-title "You are required to digitally sign this curriculum. Please follow the instructions below to complete your electronic signature."
   :pathom.mutations.curriculum.signatures.email/instructions-header "Instructions:"
   :pathom.mutations.curriculum.signatures.email/step-1 "Click the signature button below to access the signing portal"
   :pathom.mutations.curriculum.signatures.email/step-2 "Review the curriculum content and requirements carefully"
   :pathom.mutations.curriculum.signatures.email/step-3 "Enter your signature code when prompted (provided below)"
   :pathom.mutations.curriculum.signatures.email/step-4 "Complete and submit your digital signature"
   :pathom.mutations.curriculum.signatures.email/signing-code-label "Your Signature Code:"
   :services.boosts.reengagement/cta-label "Complete Learning",
   :services.boosts.reengagement/name-five-day
   "Five-Day Reengagement Boost",
   :services.boosts.reengagement/name-one-day
   "One-Day Reengagement Boost",
   :services.boosts.reengagement/subject
   "There's more to Learn: {{activity-name}}",
   :services.boosts.reengagement/title "Complete Your Learning",
   :services.email.components.banner/image-alt "View activity!",
   :services.email.components.logo/image-alt "Company Logo",
   :services.email.components.question/view-questionnaire
   "View Questionnaire",
   :services.email.containers.boost.core/personalized
   "This list of resources has been personalized based on your engagement in the Activity. Please take a few moments to review them.",
   :services.email.containers.boost.core/suggested-resources
   "Suggested Resources",
   :services.email.containers.boost.stats/activity-consumption-subtitle
   "You viewed {activityConsumption} of the {ploType}.",
   :services.email.containers.boost.stats/learning-actions-engaged
   "You have taken {learningActionsEngaged} learning actions.",
   :services.email.containers.boost.stats/moment-consumption-subtitle
   "You engaged in {momentConsumption} of the learning moments.",
   :services.email.passwordless/access-attempt
   "It looks like you're trying to access ",
   :services.email.passwordless/activity "activity",
   :services.email.passwordless/admin-app "admin app",
   :services.email.passwordless/app "app",
   :services.email.passwordless/button
   (icu/msg
    "View {type, select, activity {Activity} curriculum {Curriculum} admin {Admin App} other {App}}"),
   :services.email.passwordless/click-button ", click the button below.",
   :services.email.passwordless/contact-support
   "If you believe you should be registered, please reach out to support at: support@archemedx.com",
   :services.email.passwordless/curriculum "curriculum",
   :services.email.passwordless/display-name "Sign In",
   :services.email.passwordless/hello "Hi there,",
   :services.email.passwordless/will-expire
   "This link will expire 45 minutes after your first click.",
   :services.email.passwordless/ignore
   "If you did not request this email, please disregard it.",
   :services.email.passwordless/subject
   (icu/msg "Ready {admin, select, true {Admin } other {}}Login"),
   :services.email.passwordless/title "You're nearly there!",
   :services.email.passwordless/to-view "To view the ",
   :services.email.passwordless/unregistered
   ", but you don't appear to be registered for it.",
   :test/duplicate "Already translated"
   :test/icu-plural
   (icu/msg
    "I have {count, plural, =0 {no candies} =1 {one candy} other {# candies}}"),
   :test/inst-fmt
   (inst-fmt
    "{month-numeric-padded}/{day-padded}/{year} {hour12}:{minutes-padded} {dayperiod}")})
